import * as yup from "yup";
import { useFormik } from "formik";
import { tAuth } from "../../../i18n/useAppTranslation";

const schema = yup.object({
  code: yup.string().required(tAuth("formError.twoStepCodeRequired")),
  trustDevice: yup.boolean().required(),
});

export function useFormTwoFactorLogin({ onSubmit }) {
  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    errors,
    touched,
    isValid,
    setFieldValue,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      code: "",
      trustDevice: false,
    },
    validationSchema: schema,
    validateOnBlur: false,
    onSubmit,
  });

  const hasError = (field) => {
    return Boolean(errors[field] && touched[field]);
  };

  return {
    form: values,
    isFormValid: isValid,
    hasError,
    submit: handleSubmit,
    onFormValueChange: handleChange,
    onFormValueBlur: handleBlur,
    errors,
    setFieldValue,
  };
}
